import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M4 8h16M4 12h16M4 16h16"/>',
  f: '<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M4 8h16M4 12h16M4 16h16"/>',
  vb: '0 0 24 24',
  rao: { fill: 'none' },
  raf: { fill: 'none' },
};

export default data;
